import React from 'react';
import { BasicTab } from 'ui-lib';
import { PackageTab } from './package-tab';
import { RepositoryTab } from './repository-tab';
import { useUrlSearch } from 'hooks/use-search.hook';

export const RepositoriesAndPackages = () => {
    const { getSearchParam, setSearchParams } = useUrlSearch();
    const defaultAccountUuid = getSearchParam('accountUuid') || null;
    return (
        <React.Fragment>
            <BasicTab
                activeKey={getSearchParam('tab') ?? 'packages'}
                defaultActiveIndex={'packages'}
                onChange={(activeKey) => {
                    if (defaultAccountUuid)
                        setSearchParams({ tab: activeKey , accountUuid: defaultAccountUuid});
                    else
                        setSearchParams({ tab: activeKey });
                }}
                tabPanes={[
                    {
                        label: 'Packages',
                        key: 'packages',
                        pane: <PackageTab />,
                    },
                    {
                        label: 'Repositories',
                        key: 'repositories',
                        pane: <RepositoryTab />,
                    },
                ]}
            />
        </React.Fragment>
    );
};

